export const column = [
  { width: 230, label: '交易流水号', value: 'tradeNo' },
  { width: 160, label: '交易时间', value: 'createdAt' },
  { width: 80, label: '交易人', value: 'operatorName' },
  { width: 140, label: '手机号', value: 'mobile' },
  { width: 100, label: '交易渠道', value: 'service' },
  { width: 100, label: '交易类型', value: 'type' },
  { width: 120, label: '交易明细', value: 'note' },
  { width: 120, label: '金额变化（元）', value: 'amount' },
  { width: 100, label: '交易状态', value: 'status' },
  { width: 100, label: '付款方式', value: 'payType' },
  { width: 100, label: '付款流水号', value: 'billNo' }
]

export const transactionChannelList = ['网络调查', '检查吧', '任务广场', '培训吧', '充值', '提现', '账户间资金转移', '资金内部转移', '企业专属域名', '微信', '活动冻结', '活动解冻', '申报吧', '督导吧任务', '面对面访问', '企业管理工具', '银行卡']

export const transactionTypeList = ['充值', '余额提现', '活动奖励', '活动发奖', '资金转移', '资金转移', '资金冻结', '活动清算', '企业专属域名', '企业专属续费', '答题分享奖励', '任务广场任务结算', '面对面访问任务结算', '执行任务结算', '问卷短信群发', '平台奖励', '购买短信']

export const transactionStatusList = ['完成', '失败', '待领取']

export const transactionPayTypeList = ['', '微信', '支付宝', '其他']
